<template lang="html">
  <div class="kids">
    <v-row justify="center">
      <v-dialog max-width="300" max-height="300" height="300" v-model="showGratulations">
        <v-card>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-icon class="white--text" @click="showGratulations=false">
              mdi-close
            </v-icon>
          </v-card-actions>

          <v-card-text>
            <p>Ügyes vagy, egy kört befejeztél!
            </p>
            <p>
              <v-icon large>mdi-owl</v-icon>
            </p>

          </v-card-text>
        </v-card>
      </v-dialog>
    </v-row>

    <KidSelectMode v-if="gameMode==null"/>

    <Feladatleiras />

      <v-row v-if="gameMode=='readSoroban' || gameMode=='moveSoroban'">
        <v-col cols="12" md="7">
          <Pontok :pontok="pontok"/>
          <Soroban
            :clickDisabled="sorobanAnimationOn"
            :showResult="showColumnResults"/>
        </v-col>
        <v-col cols="12" md="5" >
          <v-btn class="primary my-3 mr-2" @click="getNumber">
            Kérem a számot!
            <v-icon small>mdi-replay</v-icon>
          </v-btn>

          <div class="userinputDisplay" v-if="gameMode=='readSoroban'">
            {{userinput}}
            <v-icon class="warning--text" v-if="userinput" @click="userinput=''">mdi-delete</v-icon>
          </div>

          <div class="showmodeoff" v-if="gameMode=='moveSoroban'">
            <div
              class="requestedNumber"
              :class="{'green--text': numberToSolve==$store.getters.displayNumber}"
              v-if="numberToSolve"
            >
              A kért szám: {{numberToSolve}}
            </div>
            <div
              class="sorobanNumber"
              :class="{'green--text': numberToSolve==$store.getters.displayNumber}"
            >
              Soroban: {{this.$store.getters.displayNumber}}
            </div>
          </div>

          <div class="szamjegyek" v-if="gameMode=='readSoroban'">
            <div
              class="digit"
              v-for="i in 10" :key="i"
              @click="userinput += i-1"
            >
              {{i-1}}
            </div>
          </div>
        </v-col>
      </v-row>

      <ComplementaryNumbers v-if="gameMode=='complements'"/>

  </div>
</template>

<script>
import Feladatleiras from '@/components/Kids/Feladatleiras.vue'
import Pontok from '@/components/Kids/Pontok.vue'
import KidSelectMode from '@/components/Kids/KidSelectMode.vue'
import ComplementaryNumbers from '@/components/Kids/ComplementaryNumbers.vue'
import Soroban from '@/components/Soroban/SorobanFull.vue'
export default {
  data(){
    return{
      userinput : '',
      pontok: 0,
      showGratulations: false,
      numberToSolve: null,
      showColumnResults: false,
    }
  },
  computed:{
    sorobanNumber(){
      return this.$store.getters.displayNumber;
    },
    gameMode(){
      return this.$store.getters['kids/gameMode']
    },
    level(){
      return this.$store.getters['kids/level']
    },
    sorobanAnimationOn(){
      if (this.gameMode=='readSoroban') {
        return true
      }else{
        return false
      }
    },
    min(){
      if (this.level==0) {
        return 1
      }
      else if (this.level==1){
        return 10
      }
      else if (this.level==2){
        return 100
      }
      else return 1
    },
    max(){
      if (this.level==0) {
        return 9
      }
      else if (this.level==1){
        return 99
      }
      else if (this.level==2){
        return 999
      }
      else return 99999999
    }
  },
  components:{
    Feladatleiras,
    Pontok,
    Soroban,
    KidSelectMode,
    ComplementaryNumbers,
  },
  methods: {
    getNumber(){
      if (this.pontok==5) {
        this.pontok = 0;
      }
      if (this.gameMode=='moveSoroban') {
        this.$store.dispatch('setDisplayNumber', 0)
      }
      this.userinput = ''
      this.numberToSolve = Math.floor(Math.random() * (this.max - this.min + 1) ) + this.min;
      if (this.gameMode=='readSoroban') {
        this.$store.dispatch('setDisplayNumber', this.numberToSolve)
      }
    },
    resetGame(){
      this.pontok = 0;
      this.numberToSolve = null;
      this.userinput = '';
      this.$store.dispatch('setDisplayNumber', 0)
    },
  },
  watch: {
    userinput(){
      if (this.userinput != 0 && this.userinput==this.$store.getters.displayNumber) {
        this.pontok +=1;
        this.$store.dispatch('setDisplayNumber', 0)
        this.userinput = ''
      }
    },
    pontok(){
      if (this.pontok==5) {
        this.showGratulations = true;
      }
    },
    sorobanNumber(){
      if (this.sorobanNumber==this.numberToSolve && this.gameMode=='moveSoroban' &&this.sorobanNumber!=0) {
        this.pontok +=1;
        this.numberToSolve = null;
      }
    },
    level(){
      this.resetGame();
    },
    gameMode(){
      this.resetGame();
    },
    $route(){
      if (this.$route.query) {
        this.$store.dispatch('kids/setGameMode',this.$route.query.mode)
      }else{
        this.$store.dispatch('kids/setGameMode',null)
      }
    }
  },
  mounted(){
    this.$store.dispatch('setDisplayNumber', 0)
    if (this.$route.query) {
      this.$store.dispatch('kids/setGameMode',this.$route.query.mode)
    }else{
      this.$store.dispatch('kids/setGameMode',null)
    }
  },
  beforeDestroy(){
    this.$store.dispatch('kids/setGameMode',null)
  }
}
</script>

<style lang="scss">
.kids{
  font-family: 'Patrick Hand', cursive;
  text-align: center;

  .userinputDisplay{
    font-size: 2rem;
    min-height: 35px;
  }
  .szamjegyek{

    display: flex;
    justify-content: center;
    flex-wrap: wrap;

    .digit{
      width: 50px;
      font-size: 2rem;
      border: 1px solid blue;
      padding: 10px 20px;
      border-radius: 5px;

      &:hover{
        background-color: pink;
        cursor: pointer;
      }

      @media(min-width: 960px){
        width: 100px;
        margin: 10px 10px;
      }
    }
  }

  .showmodeoff{
    margin-top: 50px;
    font-size: 2rem;
  }

  .requestedNumber{
    color: blue;
  }
  .sorobanNumber{
    color: orange;
  }
}

.v-card.theme--light{
  background: linear-gradient(to bottom right, red, orange);

  &> .v-card__text p{
    font-size: 1.2rem;
    text-align: center;
    font-weight: bold;
  }
}

.v-card:not(.v-sheet--tile):not(.v-card--shaped) {
    border-radius: 14px;
}

</style>
